module.exports = __webpack_public_path__ + "img/exclamation-triangle.df5c11ed.svg";